import { render, staticRenderFns } from "./aawz-markdown-render.vue?vue&type=template&id=7ea82f5e&"
import script from "./aawz-markdown-render.vue?vue&type=script&lang=js&"
export * from "./aawz-markdown-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea82f5e')) {
      api.createRecord('7ea82f5e', component.options)
    } else {
      api.reload('7ea82f5e', component.options)
    }
    module.hot.accept("./aawz-markdown-render.vue?vue&type=template&id=7ea82f5e&", function () {
      api.rerender('7ea82f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/aawz-markdown-render/aawz-markdown-render.vue"
export default component.exports